import React from 'react';
import { ContactSection } from '../components/sections';

export const ContactPage: React.FC<{ onOpenConsultation: () => void }> = ({ onOpenConsultation }) => {
  return (
    <div className="pt-20">
      <ContactSection onOpenConsultation={onOpenConsultation} />
    </div>
  );
};
